import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'displayPaymentState',
    standalone: false
})
export class DisplayPaymentStatePipe implements PipeTransform {

    transform(state: string): string {
        switch (state) {
            case 'CREATED':
                return 'Ke schválení'
            case 'READY':
                return 'Připraveno k odeslání'
            case 'SEND':
                return 'Odesláno, neuhrazeno'
            case 'PAID':
                return 'Uhrazeno'
            case 'RETURNED':
                return 'Vráceno'
            case 'STORNO':
                return 'Stornováno'
            case 'DONT_PAY':
                return 'Nevyplácet'
            case 'IMPORTED':
                return 'Importováno'
            case 'ADVANCE':
                return 'Zálohové platby'
            case 'EXTRA':
                return 'Mimořádné platby'
        }

        return ''
    }
}